import { useEffect, useState } from "react";
import { Toast as BootStrapToast, ToastContainer } from "react-bootstrap";
import PubSub from "../../services/PubSub";
import { useTranslation } from "react-i18next";

const Toast = ({ showId, hideId, delay = 5000, css = {} }) => {
    const [translate] = useTranslation();
    const [show, setShow] = useState(false);
    const [type, setType] = useState("");
    const [message, setMessage] = useState("");
    const [title, setTitle] = useState("");
    const [autohide, setAutohide] = useState(true);
    const [toastCss, setToastCss] = useState(css);

    useEffect(() => {
        const showToasterId = PubSub.subscribe(
            showId,
            ({ message, title, type, autohide, css }) => {
                setMessage(message);
                setType(type);
                if (autohide !== undefined) {
                    setAutohide(autohide);
                }
                if (css !== undefined) {
                    setToastCss(css);
                }
                if (title) {
                    setTitle(title);
                }
                setShow(true);
            }
        );

        const hideToasterId = PubSub.subscribe(hideId, () => {
            setShow(false);
        });

        return () => {
            PubSub.unsubscribe(showId, showToasterId);
            PubSub.unsubscribe(hideId, hideToasterId);
        };
    }, [showId, hideId]);

    return <ToastContainer className="p-3" position="bottom-end">
        <BootStrapToast
            show={show}
            onClose={() => setShow(false)}
            className={`toaster ${toastCss.container}`}
            delay={delay}
            autohide={autohide}
            bg="light"
        >
            <BootStrapToast.Header bsPrefix={`toast-header ${toastCss.header || ""}`} closeButton={!autohide}>
                <strong className={`h6 me-auto ${!toastCss.title ? `text-${type}` : ''} ${toastCss.title || ""}`}>
                    {
                        title
                            ? title
                            : type === "success" ? translate("OTM_SUCCESS") : translate("OTM_ERROR")
                    }
                </strong>
            </BootStrapToast.Header>
            <BootStrapToast.Body bsPrefix={`toast-body text-${type} ${toastCss.body || ""}`}>
                {message}
            </BootStrapToast.Body>
        </BootStrapToast>
    </ToastContainer>
};

export default Toast;
